const AVAILABLE_PACKS = {
    '4-pack': 4,
    '6-pack': 6
}

const BUCKET_PRICES = {
    '4-pack': 35,
    '6-pack': 52
}

const BUCKET_COMPARE_PRICES = {
    '4-pack': 45,
    '6-pack': 67
}

const BUCKET_DISCOUNT = {
    '4-pack': 1000,
    '6-pack': 1500
}

const S = {
  section: '.bundle-builder__section--reference',
  container: '.bundle-builder',
  filter: '.bundle-builder__filter',
  switcher: '.bundle-builder__selector',
  switcherRadio: '.bundle-builder__selector-radio',
  product: '.product__thumbnail.product__gridItem',
  productThumbnailAdd: '.bundle-builder__product-thumbnail--button[data-single-add]',
  productThumbnailMultipleAdd: '.bundle-builder__product-thumbnail--button[data-multiple-add]',
  bundleSidebar: '.bundle-builder__sidebar',
  bundleSidebarMobile: '.bundle-builder__sidebar--mobile',
  bundleAddToCart: '.bundle-builder__add-to-cart',
  bundleSpots: '.bundle-builder__spots',
  bundleSpotsBtgof: '.bundle-builder__spots--btgof',
  bundleSpotContainer: '.bundle-builder__spot--container',
  bundleSpotImage: '.bundle-builder__spot--image',
  bundleSpotDeleteButton: '.bundle-builder__selected-product-remove-button',
  bundleBottomLabelMobile: '.bundle-builder__label',
  bundleButtonSavingCode: '.bundle-builder__savings-code',
  bundleSubtotalPrice: '.bundle-builder__subtotal-value',
  bundleSubTotalComparedPrice: '.bundle-builder__subtotal-compared-value',
  bundleStickyMobileToggle: '.bundle-builder__sidebar--toggleable',
  bundleDiscountCodeButton: '.hero-bf-banner__code-chip',
  spot: '[data-spot]',
  hidden: 'hidden',
  active: 'is-active'
};

const IG_TEST_ID = 'e0d1fbcc-fefd-4865-b0ef-2cde54d0813b';

const PRODUCT_SPOT_TEMPLATE = `
    <div class="bundle-builder__spot--placeholder">
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18.1099C12.1217 18.1099 14.1566 17.267 15.6569 15.7667C17.1571 14.2664 18 12.2316 18 10.1099C18 7.98813 17.1571 5.9533 15.6569 4.45301C14.1566 2.95272 12.1217 2.10986 10 2.10986C7.87827 2.10986 5.84344 2.95272 4.34315 4.45301C2.84285 5.9533 2 7.98813 2 10.1099C2 12.2316 2.84285 14.2664 4.34315 15.7667C5.84344 17.267 7.87827 18.1099 10 18.1099ZM11 7.10986C11 6.84465 10.8946 6.59029 10.7071 6.40276C10.5196 6.21522 10.2652 6.10986 10 6.10986C9.73478 6.10986 9.48043 6.21522 9.29289 6.40276C9.10536 6.59029 9 6.84465 9 7.10986V9.10986H7C6.73478 9.10986 6.48043 9.21522 6.29289 9.40276C6.10536 9.59029 6 9.84465 6 10.1099C6 10.3751 6.10536 10.6294 6.29289 10.817C6.48043 11.0045 6.73478 11.1099 7 11.1099H9V13.1099C9 13.3751 9.10536 13.6294 9.29289 13.817C9.48043 14.0045 9.73478 14.1099 10 14.1099C10.2652 14.1099 10.5196 14.0045 10.7071 13.817C10.8946 13.6294 11 13.3751 11 13.1099V11.1099H13C13.2652 11.1099 13.5196 11.0045 13.7071 10.817C13.8946 10.6294 14 10.3751 14 10.1099C14 9.84465 13.8946 9.59029 13.7071 9.40276C13.5196 9.21522 13.2652 9.10986 13 9.10986H11V7.10986Z" fill="black"/>
        </svg>
    </div>
    <div class="bundle-builder__spot--image">
        <img src="" class="bundle-builder__spot-product-image">
    </div>
    <button class="bundle-builder__selected-product-remove-button" data-bundle-builder-selected-product-remove-button></button>
`;

class BundleBuilder {
    constructor({ isBtgofVariant = false, isNewYearSaleVariant = false } = {}) {
        this.container = document.querySelector(S.container);
        if (!this.container) return;

        this.isBtgofVariant = isBtgofVariant;
        this.isNewYearSaleVariant = isNewYearSaleVariant;
        this.products = Array.from(this.container.querySelectorAll(S.product)).map(el => (el._filters = new Set(el.dataset.productFilter?.split(',')), el));
        this.filters = this.container.querySelectorAll(S.filter);

        // Get switchers (use radio buttons for BTGOF, regular for others)
        if (this.isBtgofVariant) {
            this.switchers = this.container.querySelectorAll(S.switcherRadio);
        } else {
            this.switchers = this.container.querySelectorAll(S.switcher);
        }

        this.spots = this.container.querySelectorAll(S.spot);

        this.state = {
            '4-pack': [],
            '6-pack': []
        }

        this.giftState = {
            '4-pack': [],
            '6-pack': []
        }
        
        this.currentSpot = AVAILABLE_PACKS[Object.keys(AVAILABLE_PACKS)[0]]; // Default to first available pack
    
        this.container.addEventListener('click', this._onClick.bind(this));
        this._updateSubtotal();
    }

    _onClick(e) {
        if (e.target.matches(S.filter))                         this._onFilterClick(e.target);
        if (e.target.matches(S.switcher))                       this._onSwitcherClick(e.target);

        // Handle radio selector (BTGOF variant)
        const radioButton = e.target.closest(S.switcherRadio);
        if (radioButton)                                        this._onSwitcherClick(radioButton);

        if (e.target.matches(S.productThumbnailAdd))            this._onAddClick(e.target);
        if (e.target.matches(S.productThumbnailMultipleAdd))    this._onMultipleAddClick(e.target);
        if (e.target.matches(S.bundleSpotDeleteButton))         this._onDeleteSpotClick(e.target);
        if (e.target.matches(S.bundleBottomLabelMobile)
            || e.target.closest(S.bundleBottomLabelMobile))     this._onSwitchMobileSpots();
        if (e.target.matches(S.bundleAddToCart)
            || e.target.closest(S.bundleAddToCart))             this._bundleAddToCart();
        if (e.target.matches(S.bundleButtonSavingCode))         this._onSavingsCodeClick(e.target);
    }

    _onFilterClick(filter) {
        this._toggleActive(this.filters, filter);
        this._applyFilter(filter.dataset.filterValue);
    }

    _onSwitcherClick(switcher) {
        this._toggleActive(this.switchers, switcher);
        const spotId = switcher.dataset.spotReference;
        this.currentSpot = AVAILABLE_PACKS[spotId];
        this.spots.forEach(spot => {
          const isMatch = spot.dataset.spot === spotId;
          spot.classList.toggle(S.hidden, !isMatch);
        });
        this._checkSpotAvailability();
        this._updateSubtotal();
    }

    _onAddClick(button) {
        const productVariantId = button.dataset.variantId;
        const productImage = button.dataset.productImage;
        const productPrice = button.dataset.price;
        const activeSpot = this._getActiveSpot();
        const bucket = this.state[activeSpot];
        const giftBucket = this.giftState[activeSpot];
        const maxItems = this._getMaxItems(activeSpot);
        const giftMaxItems = this._getGiftMaxItems(activeSpot);
        const isGiftMode = this.isBtgofVariant && bucket.length >= maxItems && giftBucket.length < giftMaxItems;
        const isFull = bucket.length >= maxItems && (!this.isBtgofVariant || giftBucket.length >= giftMaxItems);

        // add loading state
        button.disabled = true;
        button.textContent = 'Adding...';

        setTimeout(() => {
            button.textContent = '+ Add';
            this._checkSpotAvailability();
        }, 1000);

        if (isFull) {
            this._showAlert(`Your bundle is full!  Review your selections or remove an item to add a new one.`);
            return;
        }

        if (isGiftMode) {
            giftBucket.push({
                id: Number(productVariantId),
                image: productImage,
                price: Number(productPrice)
            });
        } else {
            bucket.push({
                id: Number(productVariantId),
                image: productImage,
                price: Number(productPrice)
            });
        }

        this._renderPreview();
        this._updateAtcButton();
        this._updateSubtotal();
        if (window.innerWidth < 768) this._onSwitchMobileSpots(true);
    }

    _onMultipleAddClick(button) {
        const productVariantIds = button.dataset.variantIds.split(',');
        const productImages = button.dataset.productImages.split(',');
        const productPrice = Number(button.dataset.price);
        const packVariantId = Number(button.dataset.packVariantId);
        const activeSpot = this._getActiveSpot();
        const bucket = this.state[activeSpot];
        const maxItems = this._getMaxItems(activeSpot);
        const remainingSpots = maxItems - bucket.length;

        // Multiple-add is not available in gift mode
        if (this.isBtgofVariant && bucket.length >= maxItems) return;

        if ((bucket.length >= maxItems) || productVariantIds.length > remainingSpots) {
            this._showAlert(`You can only add ${remainingSpots} more products to complete your bundle.`);
            return
        } 
        
        const groupId = `starter-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;

        productVariantIds.forEach((productVariantId, index) => {
            bucket.push({
                id: index === 0 && packVariantId ? packVariantId : Number(productVariantId),
                displayId: Number(productVariantId),
                image: productImages[index] || productImages[0] || '',
                price: index === 0 ? productPrice : 0,
                groupId,
                isVirtual: index > 0
            })
        })

        this._renderPreview();
        this._updateAtcButton();
        this._updateSubtotal();
        if (window.innerWidth < 768) this._onSwitchMobileSpots(true);
    }

    _onDeleteSpotClick(button) {
        const spotContainer = button.closest(S.bundleSpotContainer);
        const isGiftSpot = spotContainer.classList.contains('is-free-gift');
        const activeSpot = this._getActiveSpot();

        if (isGiftSpot) {
            const giftSpots = Array.from(spotContainer.parentNode.querySelectorAll(`${S.bundleSpotContainer}.is-free-gift`));
            const giftIndex = giftSpots.indexOf(spotContainer);
            this.giftState[activeSpot].splice(giftIndex, 1);
        } else {
            const regularSpots = Array.from(spotContainer.parentNode.querySelectorAll(`${S.bundleSpotContainer}:not(.is-free-gift)`));
            const spotContainerIndex = regularSpots.indexOf(spotContainer);
            const bucket = this.state[activeSpot];
            const groupId = bucket[spotContainerIndex]?.groupId;

            if (groupId) {
                this.state[activeSpot] = bucket.filter(item => item.groupId !== groupId);
            } else {
                bucket.splice(spotContainerIndex, 1);
            }
        }

        this._rebuildSpots(activeSpot);
        this._renderPreview();
        this._updateAtcButton();
        this._updateSubtotal();
    }

    _onSwitchMobileSpots(keepOpen = false) {
        const mobileSidebarToggle = this.container.querySelector(S.bundleStickyMobileToggle);
        keepOpen ? mobileSidebarToggle && mobileSidebarToggle.classList.remove(S.hidden) : mobileSidebarToggle && mobileSidebarToggle.classList.toggle(S.hidden);
    }

    _onSavingsCodeClick(button) {
        const code = button.dataset.discountCode;
        if (!code) return;

        navigator.clipboard.writeText(code).then(() => {
            this._showAlert(`Discount code "${code}" copied to clipboard!`);
        }).catch(err => {
            console.error('Could not copy text: ', err);
        });
    }

    _renderPreview() {
        const activeSpot = this._getActiveSpot();
        const maxItems = this._getMaxItems(activeSpot);
        const items = (this.state[activeSpot] || []).slice(0, maxItems);
        this.state[activeSpot] = items;

        const giftMaxItems = this._getGiftMaxItems(activeSpot);
        const giftItems = (this.giftState[activeSpot] || []).slice(0, giftMaxItems);
        this.giftState[activeSpot] = giftItems;

        this._resetSpots(activeSpot);
        const containers = this._getSpotContainers(activeSpot, true);

        containers.forEach(container => {
            const regularSpots = Array.from(container.querySelectorAll(`${S.bundleSpotContainer}:not(.is-free-gift)`));
            const giftSpots = Array.from(container.querySelectorAll(`${S.bundleSpotContainer}.is-free-gift`));

            regularSpots.forEach((el, index) => {
                const item = items[index];
                if (!item) return;
                el.classList.add(S.active);
                el.dataset.productId = item.displayId || item.id;
                el.querySelector(`${S.bundleSpotImage} img`)?.setAttribute('src', item.image);
            });

            giftSpots.forEach((el, index) => {
                const item = giftItems[index];
                if (!item) return;
                el.classList.add(S.active);
                el.dataset.productId = item.id;
                el.querySelector(`${S.bundleSpotImage} img`)?.setAttribute('src', item.image);
            });
        });
    }

    _updateAtcButton() {
        const activeSpot = this._getActiveSpot();
        const currentSpotButtons = this.container.querySelectorAll(`${S.bundleAddToCart}[data-spot="${activeSpot}"]`);
        const bucketLength = this.state[activeSpot]?.length || 0;
        const giftBucketLength = this.isBtgofVariant ? (this.giftState[activeSpot]?.length || 0) : 0;
        const maxItems = this._getMaxItems(activeSpot);
        const giftMaxItems = this.isBtgofVariant ? this._getGiftMaxItems(activeSpot) : 0;
        const remaining = (maxItems - bucketLength) + (giftMaxItems - giftBucketLength);

        const regularFull = (this.state[activeSpot]?.length || 0) >= maxItems;
        const isGiftMode = this.isBtgofVariant && regularFull && giftBucketLength < giftMaxItems;

        currentSpotButtons.forEach(button => {
            button.classList.toggle(S.active, remaining === 0 || isGiftMode);

            const variant = button.dataset.variant;
            const isMobile = window.innerWidth < 768;
            const mobileHTML = `Add ${remaining} More and get <span class="bundle-builder__savings-value">${this._formatMoney(BUCKET_DISCOUNT[activeSpot])} OFF</span>`;

            // BTGOF variant
            if (variant === 'btgof') {
                const spotKey = button.dataset.spot;
                const freeCount = this._getFreeGiftCount(spotKey);
                const regularMax = this._getMaxItems(spotKey);
                const regularBucketLen = this.state[spotKey]?.length || 0;
                const giftBucketLen = this.giftState[spotKey]?.length || 0;
                const regularRemaining = regularMax - regularBucketLen;
                const giftRemainingCount = freeCount - giftBucketLen;
                const isInGiftMode = regularBucketLen >= regularMax && giftBucketLen < freeCount;
                const giftText = freeCount === 1 ? 'FREE GIFT' : 'FREE GIFTS';

                if (isInGiftMode) {
                    button.innerHTML = `SELECT ${giftRemainingCount} ${giftRemainingCount === 1 ? 'FREE GIFT' : 'FREE GIFTS'}`;
                } else if (remaining === 0) {
                    button.innerHTML = `BUY NOW & GET ${giftText}`;
                } else {
                    const freeText = freeCount === 1 ? '1 FREE' : '2 FREE';
                    button.innerHTML = `Add ${regularRemaining} More and get ${freeText}`;
                }
                return;
            }

            // NY Sale variant
            if (variant === 'ny-sale') {
                button.innerHTML = remaining > 0
                    ? `Add ${remaining} More`
                    : `Buy Now`;
                return;
            }

            // Original variant (with discount)
            button.innerHTML = remaining > 0
                ? (isMobile ? mobileHTML : `Add ${remaining} More`)
                : `Buy Now`;
        });

        this._updateBottomLabelMobile();
        this._checkSpotAvailability();
        if (remaining === 0 && window.innerWidth < 768) this._onSwitchMobileSpots(true);
    }

    _updateBottomLabelMobile() {
        const activeSpot = this._getActiveSpot();
        const bottomLabel = this.container.querySelector(`${S.bundleBottomLabelMobile}[data-spot="${activeSpot}"] span`);
        if (!bottomLabel) return;

        const bucketLength = this.state[activeSpot]?.length || 0;
        const giftBucketLength = this.isBtgofVariant ? (this.giftState[activeSpot]?.length || 0) : 0;
        const maxItems = this._getMaxItems(activeSpot);
        const giftMaxItems = this.isBtgofVariant ? this._getGiftMaxItems(activeSpot) : 0;
        const totalFilled = bucketLength + giftBucketLength;
        const totalMax = maxItems + giftMaxItems;

        bottomLabel.textContent = `${totalFilled}/${totalMax} Pack selected`;
    }

    _applyFilter(val) {
        if (val === 'shop-all') {
          this.products.forEach(p => p.classList.remove(S.hidden));
          return;
        }
        this.products.forEach(p => {
          const hide = !p._filters.has(val) && val !== 'all';
          p.classList.toggle(S.hidden, hide);
        });
    }
    
    _toggleActive(group, activeEl) {
        group.forEach(el => el.classList.remove(S.active));
        activeEl.classList.add(S.active);
    }

    _getSpotContainers(spotKey = this._getActiveSpot(), includeMobile = true) {
        const containers = [];

        // Desktop spots container (either .bundle-builder__spots or .bundle-builder__spots--btgof)
        const desktopSpots = this.container.querySelector(`${S.bundleSidebar} ${this.isBtgofVariant ? S.bundleSpotsBtgof : S.bundleSpots}[data-spot="${spotKey}"]`);
        if (desktopSpots) containers.push(desktopSpots);

        // Mobile spots container
        if (includeMobile) {
            const mobileSpots = this.container.querySelector(`${S.bundleSidebarMobile} ${this.isBtgofVariant ? S.bundleSpotsBtgof : S.bundleSpots}[data-spot="${spotKey}"]`);
            if (mobileSpots) containers.push(mobileSpots);
        }

        return containers;
    }

    _getFreeGiftCount(spotKey = this._getActiveSpot()) {
        if (!this.isBtgofVariant) return 0;
        // 4-pack has 1 free gift, 6-pack has 2 free gifts
        return spotKey === '4-pack' ? 1 : 2;
    }

    _getGiftMaxItems(spotKey = this._getActiveSpot()) {
        return this._getFreeGiftCount(spotKey);
    }

    _getFreeGiftData(spotKey = this._getActiveSpot()) {
        const btgofContainer = this.container.querySelector(`${S.bundleSidebar} ${S.bundleSpotsBtgof}[data-spot="${spotKey}"]`);
        if (!btgofContainer) return {};
        const btgofElement = btgofContainer.querySelector('.is-free-gift');

        return btgofElement ? {
            id: Number(btgofElement.dataset.productId),
            image: btgofElement.querySelector(`${S.bundleSpotImage} img`)?.getAttribute('src') || '',
            price: Number(btgofElement.dataset.originalPrice) || 0
        } : {};
    }

    _getMaxItems(spotKey = this._getActiveSpot()) {
        const freeGiftCount = this._getFreeGiftCount(spotKey);
        return Math.max(0, (AVAILABLE_PACKS[spotKey] || 0) - freeGiftCount);
    }

    _resetSpots(spotKey = this._getActiveSpot()) {
        const containers = this._getSpotContainers(spotKey, true);
        containers.forEach(container => {
            const spots = container.querySelectorAll(S.bundleSpotContainer);
            spots.forEach(spot => {
                spot.classList.remove(S.active);
                spot.dataset.productId = '';
                spot.querySelector(`${S.bundleSpotImage} img`)?.setAttribute('src', '');
            });
        });
    }

    _appendSpot(spotKey = this._getActiveSpot()) {
        const spotContainer = document.createElement('div');
        spotContainer.classList.add(S.bundleSpotContainer.replace('.', ''));
        spotContainer.innerHTML = PRODUCT_SPOT_TEMPLATE;

        const containers = this._getSpotContainers(spotKey, true);
        containers.forEach((container, index) => {
            const node = index === 0 ? spotContainer : spotContainer.cloneNode(true);
            container.appendChild(node);
        });

        return spotContainer;
    }

    _rebuildSpots(spotKey) {
        const totalSpots = this._getMaxItems(spotKey);
        const containers = this._getSpotContainers(spotKey, true);

        containers.forEach(container => {
            if (!container) return;

            const giftNodes = Array.from(container.querySelectorAll('.is-free-gift')).map(node => {
                const clone = node.cloneNode(true);
                clone.classList.remove(S.active);
                clone.dataset.productId = '';
                const img = clone.querySelector(`${S.bundleSpotImage} img`);
                if (img) img.setAttribute('src', '');
                return clone;
            });
            container.innerHTML = '';

            for (let i = 0; i < totalSpots; i++) {
                const spotContainer = document.createElement('div');
                spotContainer.classList.add(S.bundleSpotContainer.replace('.', ''));
                spotContainer.innerHTML = PRODUCT_SPOT_TEMPLATE;
                container.appendChild(spotContainer);
            }

            giftNodes.forEach(node => container.appendChild(node));
        });
    }

    _checkSpotAvailability() {
        const activeSpot = this._getActiveSpot();
        const bucketLength = this.state[activeSpot]?.length || 0;
        const giftBucketLength = this.giftState[activeSpot]?.length || 0;
        const maxItems = this._getMaxItems(activeSpot);
        const giftMaxItems = this._getGiftMaxItems(activeSpot);

        const isGiftMode = this.isBtgofVariant && bucketLength >= maxItems && giftBucketLength < giftMaxItems;
        const isFull = bucketLength >= maxItems && (!this.isBtgofVariant || giftBucketLength >= giftMaxItems);

        const singleAddButtons = this.container.querySelectorAll(S.productThumbnailAdd);
        const multipleAddButtons = this.container.querySelectorAll(S.productThumbnailMultipleAdd);

        if (isFull) {
            singleAddButtons.forEach(button => { button.disabled = true; });
            multipleAddButtons.forEach(button => { button.disabled = true; });
            return;
        }

        if (isGiftMode) {
            multipleAddButtons.forEach(button => { button.disabled = true; });
            singleAddButtons.forEach(button => {
                const productEl = button.closest(S.product);
                const filters = (productEl?.dataset.productHandle || '').split(',').map(f => f.trim()).filter(Boolean);
                button.disabled = filters.includes('low-carb-chocolate-rolls') || filters.includes('low-carb-cinnamon-rolls');
            });
            return;
        }

        // Regular mode
        singleAddButtons.forEach(button => { button.disabled = false; });
        multipleAddButtons.forEach(button => { button.disabled = false; });

        if (bucketLength > 0 && bucketLength < maxItems) {
            multipleAddButtons.forEach(button => {
                const productVariantIds = button.dataset.variantIds.split(',');
                button.disabled = productVariantIds.length > (maxItems - bucketLength);
            });
        }
    }

    _getActiveSpot() {
        return Object.keys(AVAILABLE_PACKS).find(key => AVAILABLE_PACKS[key] === this.currentSpot)
    }

    _updateSubtotal() {
        const totalsContainers = this.container.querySelectorAll('.bundle-builder__totals');

        totalsContainers.forEach(totalsContainer => {
            const comparedSubtotalEl = totalsContainer.querySelectorAll(S.bundleSubTotalComparedPrice);
            comparedSubtotalEl.forEach(el => el.classList.add('hidden'));
            
            const spotKey = totalsContainer.dataset.spot;
            const subtotalEl = totalsContainer.querySelectorAll(S.bundleSubtotalPrice);
            if (!spotKey || !subtotalEl) return;
            const bucketLength = this.state[spotKey]?.length || 0;
            const maxItems = this._getMaxItems(spotKey);

            const subtotal = (this.state[spotKey] || []).reduce((sum, item) => {
                return sum + (Number(item.price) || 0);
            }, 0);

            if (bucketLength === maxItems && !this.isBtgofVariant && !this.isNewYearSaleVariant) {
                if (!!!comparedSubtotalEl) return
                const calculateSubtotalPrice = subtotal - BUCKET_DISCOUNT[spotKey];
                subtotalEl.forEach(el => el.textContent = this._formatMoney(calculateSubtotalPrice));
                comparedSubtotalEl.forEach(el => {
                    el.textContent = this._formatMoney(subtotal);
                    el.classList.remove('hidden');
                });

                return
            }

            if (bucketLength === maxItems && this.isBtgofVariant) {
                const giftBucket = this.giftState[spotKey] || [];
                const giftMaxItems = this._getGiftMaxItems(spotKey);
                subtotalEl.forEach(el => el.textContent = this._formatMoney(subtotal));
                if (giftBucket.length === giftMaxItems) {
                    if (!!!comparedSubtotalEl) return;
                    const freeGiftPrice = giftBucket.reduce((sum, item) => sum + (Number(item.price) || 0), 0);
                    comparedSubtotalEl.forEach(el => {
                        el.textContent = this._formatMoney(subtotal + freeGiftPrice);
                        el.classList.remove('hidden');
                    });
                }

                return;
            }

            if (bucketLength === maxItems && this.isNewYearSaleVariant) {
                if (!!!comparedSubtotalEl) return
                const discountAmount = Math.round(subtotal * 0.26);
                const calculateSubtotalPrice = subtotal - discountAmount;
                subtotalEl.forEach(el => el.textContent = this._formatMoney(calculateSubtotalPrice));
                comparedSubtotalEl.forEach(el => {
                    el.textContent = this._formatMoney(subtotal);
                    el.classList.remove('hidden');
                });

                return
            }

            subtotalEl.forEach(el => el.textContent = this._formatMoney(subtotal));
        });
    }

    _formatMoney(amountInCents = 0) {
        const cents = Math.max(0, Math.round(Number(amountInCents) || 0));
        return `$${(cents / 100).toFixed(2)}`;
    }

    _showAlert(
        message,
        {
          container = document.body,
          baseClass = 'bundle-builder-alert-box',
          textClassSuffix = '--text',
          activeClass = 'is-active',
          showDelay = 50,
          visibleDuration = 3000
        } = {}
      ) {
        const existing = container.querySelector(`.${baseClass}`);
        if (existing) existing.remove();
      
        const alertBox = document.createElement('div');
        alertBox.className = baseClass;
      
        const alertText = document.createElement('span');
        alertText.className = baseClass + textClassSuffix;
        alertText.textContent = message;
      
        alertBox.appendChild(alertText);
        container.appendChild(alertBox);
      
        requestAnimationFrame(() => {
          setTimeout(() => alertBox.classList.add(activeClass), showDelay);
        });
      
        return new Promise((resolve) => {
          setTimeout(() => {
            alertBox.classList.remove(activeClass);
      
            const onTransitionEnd = (e) => {
              if (e.target === alertBox) {
                alertBox.removeEventListener('transitionend', onTransitionEnd);
                alertBox.remove();
                resolve();
              }
            };
            alertBox.addEventListener('transitionend', onTransitionEnd);
          }, visibleDuration);
        });
    }

    async _bundleAddToCart() {
        const currentSpot = this._getActiveSpot();
        const bucket = this.state[currentSpot];
        const giftBucket = this.isBtgofVariant ? (this.giftState[currentSpot] || []) : [];
        const requiredItems = this._getMaxItems(currentSpot);
        const giftRequiredItems = this.isBtgofVariant ? this._getGiftMaxItems(currentSpot) : 0;
        const bundleHash = this.generateShortHash();

        const totalRemaining = (requiredItems - bucket.length) + (giftRequiredItems - giftBucket.length);
        if (totalRemaining > 0) {
            this._showAlert(`Please add ${totalRemaining} more products to complete your ${currentSpot}.`);
            document.querySelector(S.section)?.scrollIntoView({
                behavior: 'smooth'
            });
            return;
        }

        const body = {
            items: [
                ...bucket.filter(item => !item.isVirtual).map(item => ({
                    id: item.id,
                    quantity: 1,
                    properties: {
                        '_bundle-hash': bundleHash,
                        '_bundle-spot': currentSpot,
                        ...(this.isNewYearSaleVariant && { '_is-new-year-sale': true })
                    }
                })),
                ...giftBucket.map(item => ({
                    id: item.id,
                    quantity: 1,
                    properties: {
                        '_bundle-hash': bundleHash,
                        '_bundle-spot': currentSpot,
                        '_is-free-gift': true
                    }
                }))
            ]
        };

        await fetch('/cart/clear.js');

        const req = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        await req.json();

        if (req.ok) window.location.href = '/checkout';
    }

    generateShortHash() {
        return Math.random().toString(36).slice(2, 14);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('.bundle-builder__section--reference');
    const isBtgofVariant = el?.dataset?.isBtgofVariant === 'true';

    const isNewYearSaleVariant = el?.dataset?.isNewYearSaleVariant === 'true';

    const bundleBuilder = new BundleBuilder({ isBtgofVariant, isNewYearSaleVariant });
    console.log('Bundle Builder initialized:', bundleBuilder);

    const discountCodeSaverButton = document.querySelectorAll(S.bundleDiscountCodeButton);
    discountCodeSaverButton.forEach(button => {
        button.addEventListener('click', () => {
            const code = button.dataset.discountCode;
            if (!code) return;

            navigator.clipboard.writeText(code).then(() => {
                bundleBuilder._showAlert(`Discount code "${code}" copied to clipboard!`);
            }).catch(err => {
                console.error('Could not copy text: ', err);
            });
        });
    });
})